import createRecursiveFunctionForAnalytics from 'Utils/createRecursiveFunctionForAnalytics';
import { formatProduct } from 'Jsx/Utils/buyProduct';
import getFeatureFlag from 'Utils/getFeatureFlag';

export const trackAnalytics = course => {
  const trackGoogleAnalytics = () => {
    if (window.ga) {
      const product = formatProduct(course, 'course');

      window.ga('create', 'UA-60829200-1', { name: 'crehCourseDetail' });
      window.ga('crehCourseDetail.require', 'ec');

      window.ga(
        'crehCourseDetail.set',
        'currencyCode',
        course.prices.currencyCode,
      );
      window.ga('crehCourseDetail.ec:addProduct', {
        id: product.productId,
        name: product.name,
        price: course.prices.price,
      });

      window.ga('crehCourseDetail.ec:setAction', 'detail');
      window.ga('crehCourseDetail.send', 'pageview');
    }
  };

  // ================ Start tracking code  ================== //

  // Google tracking don't need to wait PRODUCTION environment. The views in analytics filter crehana office IPs
  createRecursiveFunctionForAnalytics(trackGoogleAnalytics)();

  // Super duper important!!
  // DONT DELETE THIS!!!
  if (process.env.NODE_ENV === 'production') {
    // FACEBOOK PIXEL
    if (window.fbq) {
      window.fbq('track', 'PageView');
      window.fbq('track', 'ViewContent', {
        content_name: course.title,
        content_ids: [course.originalId.toString()],
        content_type: 'product',
        value: course.price,
        currency: 'USD',
      });
    }

    // DATALAYER FOR GOOGLE ADS DYNAMIC REMARKETING
    (window.dataLayer || []).push({
      google_tag_params: {
        dynx_itemid: course.originalId,
        dynx_itemid2: `course_${course.originalId}`,
        dynx_pagetype: 'offerdetail',
        dynx_totalvalue: course.price,
      },
    });
  }

  // ================ End tracking code  ================== //
};

export default trackAnalytics;
